document.addEventListener( 'DOMContentLoaded', function() {
	const container = document.querySelector( '.blog-post-filter' );
	if ( ! container ) {
		return;
	}

	let selectedCategory = container.dataset.selectedCategory || '';
	const postsPerLoad = 8;
	let allPosts = [];
	let displayedPosts = [];
	const categories = {}; // Store category ID -> Name mapping

	// Fetch categories first
	const fetchCategories = () => {
		fetch( '/wp-json/wp/v2/categories?per_page=100' )
			.then( ( res ) => res.json() )
			.then( ( data ) => {
				data.forEach( ( cat ) => {
					categories[ cat.id ] = cat.name;
				} );
				renderCategories();
				fetchPosts( selectedCategory );
			} )
			.catch( async ( err ) => {
				console.error( 'Error fetching categories:', err );
				if ( err.response ) {
					console.log( await err.response.text() ); // Log the actual response body
				}
			} );
	};

	// Render category buttons
	const renderCategories = () => {
		const categoryContainer = document.createElement( 'div' );
		categoryContainer.className = 'filter-bar d-flex align-items-center flex-wrap post-categories';

		// "All Works" button
		const allButton = document.createElement( 'button' );
		allButton.textContent = 'all posts';
		allButton.className = ! selectedCategory ? 'active' : '';

		// Add inline style for --post_tag_color
		allButton.style.setProperty( '--post_tag_color', '#000000' );

		allButton.addEventListener( 'click', () => {
			selectedCategory = '';
			renderCategories();
			fetchPosts( '' );
		} );

		categoryContainer.appendChild( allButton );

		// Category buttons
		Object.keys( categories ).forEach( ( catId ) => {
			const button = document.createElement( 'button' );
			button.textContent = categories[ catId ];

			// Default color
			let categoryColor = '#0061f0';

			// Fetch ACF field value by taxonomy ID
			fetch( `/wp-json/wp/v2/categories/${ catId }` )
				.then( ( response ) => response.json() )
				.then( ( data ) => {
					categoryColor = data.acf?.emt_var_portcat_catcolor || '#0061f0';
					button.style.setProperty( '--post_tag_color', categoryColor ); // Set CSS variable
				} )
				.catch( ( error ) => console.error( 'Error fetching category color:', error ) );

			button.className = selectedCategory == catId ? 'active' : '';

			button.addEventListener( 'click', () => {
				selectedCategory = catId;
				renderCategories();
				fetchPosts( catId );
			} );

			categoryContainer.appendChild( button );
		} );

		// Replace or add category container
		const existingCategoryContainer = container.querySelector( '.post-categories' );
		if ( existingCategoryContainer ) {
			container.replaceChild( categoryContainer, existingCategoryContainer );
		} else {
			container.prepend( categoryContainer );
		}

		// ✅ Add the `em-s156` div **AFTER** the categories
		const spacerDiv = document.createElement( 'div' );
		spacerDiv.className = 'em-s128';

		// Remove old one if exists & append new
		const existingSpacer = container.querySelector( '.em-s128' );
		if ( existingSpacer ) {
			existingSpacer.remove();
		}
		container.appendChild( spacerDiv );
	};

	// Fetch posts based on category selection
	const fetchPosts = ( category = '' ) => {
		const categoryQuery = category ? '&categories=' + category : '';
		fetch( '/wp-json/wp/v2/posts?per_page=100&_embed' + categoryQuery )
			.then( ( res ) => res.json() )
			.then( ( data ) => {
				allPosts = data;
				displayedPosts = allPosts.slice( 0, postsPerLoad );
				renderPosts();
			} )
			.catch( ( err ) => console.error( 'Error fetching posts:', err ) );
	};

	// Render posts
	const renderPosts = () => {
		const existingGrid = container.querySelector( '.blog-post-archive' );
		if ( existingGrid ) {
			existingGrid.remove();
		}

		const grid = document.createElement( 'div' );
		grid.className = 'blog-post-archive post-archive two-columns';

		if ( displayedPosts.length === 0 ) {
			grid.innerHTML = '<p>No works found.</p>';
		} else {
			displayedPosts.forEach( ( post ) => {
				const item = document.createElement( 'div' );
				item.className = 'post-box column';

				const link = document.createElement( 'a' );
				link.href = post.link;

				const imgContainer = document.createElement( 'div' );
				imgContainer.className = 'post-box-img post-image';

				const imageUrl = post._embedded?.[ 'wp:featuredmedia' ]?.[ 0 ]?.source_url;

				if ( imageUrl ) {
					const img = document.createElement( 'img' );
					img.src = imageUrl;
					img.alt = post.title.rendered;
					imgContainer.appendChild( img );
				}

				const content = document.createElement( 'div' );
				content.className = 'post-content';
				const titleContainer = document.createElement( 'div' );
				titleContainer.className = 'post-box-title post-title';
				const title = document.createElement( 'h4' );
				title.innerHTML = post.title.rendered;
				titleContainer.appendChild( title );

				const metaContainer = document.createElement( 'div' );
				metaContainer.className = 'post-box-meta d-flex align-items-center justify-content-between';

				const categoryContainer = document.createElement( 'div' );
				categoryContainer.className = 'post-tag';

				// Create date container
				const dateContainer = document.createElement( 'div' );
				dateContainer.className = 'post-date';

				// Format and insert the post date
				const postDate = new Date( post.date );
				const formattedDate = postDate.toLocaleDateString( 'en-US', {
				    year: 'numeric',
				    month: 'long',
				    day: 'numeric',
				} );
				dateContainer.textContent = formattedDate;

				if ( post.categories?.length ) {
				    post.categories.forEach( ( catId ) => {
				        if ( categories[ catId ] ) {
				            const catSpan = document.createElement( 'span' );
				            catSpan.textContent = categories[ catId ];

				            // Default color
				            let categoryColor = '#0061F0';

				            // Fetch ACF field value by taxonomy ID
				            fetch( `/wp-json/wp/v2/categories/${ catId }` )
				                .then( ( response ) => response.json() )
				                .then( ( data ) => {
				                    categoryColor = data.acf?.emt_var_portcat_catcolor || '#0061F0';
				                    catSpan.style.setProperty( '--post_tag_color', categoryColor );
				                } )
				                .catch( ( error ) => console.error( 'Error fetching category color:', error ) );

				            categoryContainer.appendChild( catSpan );
				        }
				    } );
				}

				// Append category and date to meta container
				metaContainer.appendChild( categoryContainer );
				metaContainer.appendChild( dateContainer );

				// Append metaContainer to content
				content.appendChild( metaContainer );
				content.appendChild( titleContainer );
				link.appendChild( imgContainer );
				link.appendChild( content );
				item.appendChild( link );
				grid.appendChild( item );
			} );
		}

		container.appendChild( grid );

		// Load More Button
		const existingSpacer = container.querySelector( '.em-s128' );
		if ( existingSpacer ) {
			existingSpacer.remove();
		}

		const existingLoadMore = container.querySelector( '.load-more' );
		if ( existingLoadMore ) {
			existingLoadMore.remove();
		}

		if ( displayedPosts.length < allPosts.length ) {
			// Create Spacer Div
			const spacerDiv = document.createElement( 'div' );
			spacerDiv.className = 'em-s128';
			container.appendChild( spacerDiv );

			// Create Load More Wrapper
			const loadMoreWrapper = document.createElement( 'div' );
			loadMoreWrapper.className = 'posts-btn';

			const loadMoreBtn = document.createElement( 'button' );
			loadMoreBtn.className = 'load-more button';
			loadMoreBtn.textContent = 'Load More';
			loadMoreBtn.addEventListener( 'click', ( event ) => {
				event.preventDefault(); // Prevents any unexpected page behavior

				const scrollPosition = window.scrollY; // Store scroll position

				displayedPosts = allPosts.slice( 0, displayedPosts.length + postsPerLoad );
				renderPosts();

				window.scrollTo( { top: scrollPosition, behavior: 'instant' } ); // Maintain scroll position
			} );

			loadMoreWrapper.appendChild( loadMoreBtn );
			container.appendChild( loadMoreWrapper );
		}
	};

	fetchCategories();
} );
